<template>
    <tr>
        <!-- for mobile -->
        <td class="is-hidden-desktop">
            <p class="mb-0">
                <span class="has-text-weight-semibold">
                    {{ row.dteTransactionDate | formatDate }}
                </span>
                <br />
                {{ row.memDescription }}
                <br />
                <small class="is-size-7 has-text-grey">
                    {{ row.strPropertyPortfolio }}
                    <span v-if="row.strPropertyAddress">
                        <br />
                        ({{ row.strPropertyAddress }})
                    </span>
                </small>
            </p>
            <p
                v-if="row.Attachment"
                class="mt-2"
            >
                <b-button
                    tag="a"
                    :href="downloadUrl"
                    size="is-small"
                    icon-left="cloud-download-alt"
                >
                    Download
                </b-button>
            </p>
        </td>
        <td class="is-hidden-desktop has-text-right">
            <span v-if="hasReceipts">
                +&pound;{{ row.dblReceipts | currency }}
            </span>

            <span v-if="hasPayments">
                -&pound;{{ row.dblPayments | currency }}
            </span>
        </td>

        <!-- for tablet and up -->
        <td class="is-hidden-touch">
            {{ row.dteTransactionDate | formatDate }}
        </td>
        <td class="is-hidden-touch is-hidden-desktop-only">
            {{ row.strAccountPeriodAlt }}
        </td>
        <td class="is-hidden-touch">
            {{ row.memDescription }}
        </td>
        <td class="is-hidden-touch">
            {{ row.strPropertyPortfolio }}
            <span v-if="row.strPropertyAddress">
                ({{ row.strPropertyAddress }})
            </span>
        </td>
        <td class="is-hidden-touch has-text-right">
            <span v-if="hasReceipts">
                &pound;{{ row.dblReceipts | currency }}
            </span>
        </td>
        <td class="is-hidden-touch has-text-right">
            <span v-if="hasPayments">
                &pound;{{ row.dblPayments | currency }}
            </span>
        </td>
        <td class="is-hidden-touch has-text-right">
            {{ row.RunningBalance | currency | withPoundSymbol }}
        </td>
        <td class="is-hidden-touch">
            <b-button
                v-if="row.Attachment"
                tag="a"
                :href="downloadUrl"
                icon-left="cloud-download-alt"
            >
                Download
            </b-button>
        </td>
    </tr>
</template>

<script>
export default {
    props: {
        row: {
            type: Object,
            required: true,
        },
    },

    computed: {
        downloadUrl: function () {
            return `/contacts/transactions/${this.row.TransactionPK}/attachment`;
        },
        hasReceipts: function () {
            return (this.row.dblReceipts && parseFloat(this.row.dblReceipts) > 0);
        },
        hasPayments: function () {
            return (this.row.dblPayments && parseFloat(this.row.dblPayments) > 0);
        },
    },
};
</script>
